export function getToday() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}/${month}/${day}`;
}

export function getLastMonth() {
  const today = new Date();
  const year = today.getFullYear();
  const currentMonth = today.getMonth();
  const lastMonthDate = new Date(year, currentMonth - 1, today.getDate());

  const month = String(lastMonthDate.getMonth() + 1).padStart(2, '0');
  return `${lastMonthDate.getFullYear()}/${month}/${String(today.getDate()).padStart(2, '0')}`;
}

export function getLastWeek() {
  const today = new Date();
  const lastWeekDate = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000);
  return `${lastWeekDate.getFullYear()}/${String(lastWeekDate.getMonth() + 1).padStart(
    2,
    '0'
  )}/${String(lastWeekDate.getDate()).padStart(2, '0')}`;
}

export function isToday(date) {
  return date === getToday() || !date;
}

export function formatDateRange(from, to) {
  if (!from && isToday(to)) {
    return 'All Time';
  } else if (from === getLastMonth() && isToday(to)) {
    return 'Last Month';
  } else if (from === getLastWeek() && isToday(to)) {
    return 'Last Week';
  }
  return `${from} - ${to}`;
}
